import React, { Component } from 'react';
import styled from 'styled-components';
import { Form, Switch, InputNumber, Col } from 'antd';
import PropTypes from 'prop-types';
import isEqual from 'lodash.isequal';

const FormItem = Form.Item;

const Wrapper = styled.div`
  .ant-form-item-label label {
    color: white;
  }

  .ant-switch {
    background-color: lightgrey;
  }

  .ant-switch-checked {
    background-color: #1890ff;
  }
`;

class AxisRangeSelector extends Component {
  static propTypes = {
    axisConfig: PropTypes.object,
  };

  static defaultProps = {
    axisConfig: {},
  };

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.axisConfig, nextProps.axisConfig)) {
      this.props.form.resetFields();
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { axisConfig } = this.props;
    return (
      <Wrapper>
        <h2 style={{ color: 'white', marginTop: '5px' }}>Y AXIS</h2>
        <Form onSubmit={this.handleSubmit} layout="vertical">
          <FormItem>
            <Col span={10}>
              <FormItem label="MIN">
                {getFieldDecorator('minValue', {
                  initialValue: axisConfig.minValue,
                })(<InputNumber />)}
              </FormItem>
            </Col>
            <Col span={2} />
            <Col span={10}>
              <FormItem label="MAX">
                {getFieldDecorator('maxValue', {
                  initialValue: axisConfig.maxValue,
                })(<InputNumber />)}
              </FormItem>
            </Col>
          </FormItem>
          <FormItem label="FIXED AXIS" style={{ color: 'white' }}>
            {getFieldDecorator('static', {
              valuePropName: 'checked',
              initialValue: axisConfig.static || false,
            })(<Switch onChange={this.handleSubmit} />)}
          </FormItem>
        </Form>
      </Wrapper>
    );
  }
}

export default Form.create({
  onValuesChange: (props, value) => {
    props.onChange(value);
  },
})(AxisRangeSelector);



// WEBPACK FOOTER //
// ./src/components/ChartView/AxisRangeSelector.js